import React, { useContext } from "react";

import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext
import "./Contactus.css";
import SEO from "../components/SEO";

const Contactus = () => {
  const { language } = useContext(LanguageContext); // Get the current language
 // ✅ **SEO Metadata for Contact Us Page**
 const metaTitle = "Contact Us - Snapseed QR Codes | Get in Touch";
 const metaDescription = "Have questions about Snapseed QR codes? Contact us for support, inquiries, and collaboration opportunities.";
 const metaUrl = "https:/www.snapseedqrcodes.download/contact";
 const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

 // ✅ **Schema Markup for Google SEO**
 const schemaMarkup = {
   "@context": "https://schema.org",
   "@type": "ContactPage",
   "headline": metaTitle,
   "description": metaDescription,
   "url": metaUrl,
   "image": metaImage,
   "contactPoint": {
     "@type": "ContactPoint",
     "email": "snapseedqrcodes.download@gmail.com",
     "contactType": "customer support",
     "areaServed": "Global",
     "availableLanguage": ["English", "Hindi"]
   },
   "publisher": {
     "@type": "Organization",
     "name": "Snapseed QR Codes",
     "logo": metaImage
   }
 };
  return (
    <div>
      {/* Use the SEO Component */}
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
      />

      <section className="snapseed">
        <h2>{language === "english" ? "Contact Us" : "संपर्क करें"}</h2>
        <p className="section-description searchable-content">
          {language === "english"
            ? "We are here for any questions about our QR codes or services."
            : "हम आपकी QR कोड या सेवाओं के बारे में किसी भी प्रश्न के लिए यहाँ हैं।"}
        </p>

        <h3>{language === "english" ? "Get in Touch" : "संपर्क में रहें"}</h3>
        <p className="section-description searchable-content">
          <b>
            {language === "english"
              ? "Email: snapseedqrcodes.download@gmail.com"
              : "ईमेल: snapseedqrcodes.download@gmail.com"}
            <br />
            {language === "english"
              ? "Website: www.snapseedqrcodes.download"
              : "वेबसाइट: www.snapseedqrcodes.download"}
          </b>
        </p>

        <h3>{language === "english" ? "What to Expect" : "क्या उम्मीद करें"}</h3>
        <p className="section-description searchable-content">
          <h5>{language === "english" ? "When you email us:" : "जब आप हमें ईमेल करेंगे:"}</h5>
          <ul>
            <li>
              {language === "english"
                ? "We will respond within 2 business days."
                : "हम 2 कार्य दिवसों के भीतर जवाब देंगे।"}
            </li>
            <li>
              {language === "english"
                ? "We are available from Monday to Friday."
                : "हम सोमवार से शुक्रवार तक उपलब्ध रहते हैं।"}
            </li>
            <li>
              {language === "english"
                ? "You will receive personalized attention from our team."
                : "हमारी टीम से आपको व्यक्तिगत ध्यान मिलेगा।"}
            </li>
          </ul>
        </p>

        <h3>{language === "english" ? "How We Can Help" : "हम कैसे मदद कर सकते हैं"}</h3>
        <p className="section-description searchable-content">
          <h5>
            {language === "english"
              ? "We are ready to assist you with:"
              : "हम निम्नलिखित में आपकी सहायता के लिए तैयार हैं:"}
          </h5>
          <ul>
            <li>
              {language === "english"
                ? "Questions about our QR codes"
                : "हमारे QR कोड्स के बारे में प्रश्न"}
            </li>
            <li>
              {language === "english"
                ? "Technical support"
                : "तकनीकी सहायता"}
            </li>
            <li>
              {language === "english"
                ? "Website feedback"
                : "वेबसाइट प्रतिक्रिया"}
            </li>
            <li>
              {language === "english"
                ? "Partnership opportunities"
                : "साझेदारी के अवसर"}
            </li>
            <li>
              {language === "english"
                ? "General inquiries"
                : "सामान्य पूछताछ"}
            </li>
          </ul>
        </p>

        <h3>{language === "english" ? "Before You Write" : "लिखने से पहले"}</h3>
        <p className="section-description searchable-content">
          {language === "english"
            ? "To help us serve you better, please include:"
            : "हमें आपकी बेहतर सेवा करने में मदद के लिए कृपया शामिल करें:"}
          <ul>
            <li>{language === "english" ? "Your name" : "आपका नाम"}</li>
            <li>
              {language === "english"
                ? "A clear description of your question"
                : "आपके प्रश्न का स्पष्ट विवरण"}
            </li>
            <li>
              {language === "english"
                ? "Any relevant details related to your situation"
                : "आपकी स्थिति से संबंधित कोई भी प्रासंगिक विवरण"}
            </li>
            <li>
              {language === "english"
                ? "Screenshots (if you are experiencing technical issues)"
                : "स्क्रीनशॉट्स (यदि आपको तकनीकी समस्याएं हो रही हैं)"}
            </li>
          </ul>
        </p>

        <p className="section-description searchable-content">
          {language === "english"
            ? "Note: For urgent matters, please write 'URGENT' in the subject line of your email. We strive to respond to all emails promptly and professionally."
            : "नोट: तत्काल मामलों के लिए, कृपया अपनी ईमेल विषय पंक्ति में 'URGENT' लिखें। हम सभी ईमेलों का त्वरित और पेशेवर ढंग से जवाब देने का प्रयास करते हैं।"}
        </p>
      </section>
    </div>
  );
};

export default Contactus;
